export default "__VITE_PUBLIC_ASSET__1133987f__"